module.exports = __webpack_public_path__ + "img/t2-19.1ccb2638.svg";